<template>
  <div class="footer-payments">
    <ul class="footer-payments__list">
      <li
        v-for="item in $options.static.paymentsList"
        :key="item.name"
        class="footer-payments__item"
      >
        <img
          :src="`/img/footer/payments/${item.src}.svg`"
          class="footer-payments__icon"
          :alt="item.name"
        />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'FooterPayments' ,
  static: {
    paymentsList: [
      { name: 'visa', src: 'visa' },
      { name: 'mastercard', src: 'mastercard' },
      { name: 'apple pay', src: 'apple' },
      { name: 'google pay', src: 'google' },
    ],
  },
}
</script>

<style lang="scss" scoped src="./style.scss"></style>
